import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

export default {
  install() {
    extend('required', {
      ...rules.required,
      message: 'Required'
    });

    extend('email', {
      ...rules.email
    });

    extend('min_value', {
      ...rules.min_value, params: ['min'], message: 'Min value: {min}'
    });

    extend('max_value', {
      ...rules.max_value,
      params: ['max'],
      message: 'Max value: {max}'
    });

    extend('uniqueIn', {
      params: ['keys'],
      validate(value, {keys}) {
        const values = [].concat(keys);
        return values.filter(k => k === value).length === 1;
      },
      message: 'The field value must be unique.'
    });

    extend('fileRequired', {
      params: ['fileName'],
      validate(value, {fileName = null} = {}) {
        return {
          required: true,
          valid: !!(value || fileName)
        };
      },
      computesRequired: true
    });
  }
};
